module.exports = __webpack_public_path__ + "img/BANKSTATEMENT.5f61a7cf.png";